var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPanelAddIllustration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.61 11.62H12.9V3.85997H15.44V3.31997H1.87V22.65H21.16V9.32997H20.62V11.61L20.61 11.62ZM12.36 3.85997V16.86H2.41V3.85997H12.37H12.36ZM2.41 17.41H12.37V22.12H2.41V17.41ZM12.91 22.12V12.16H20.62V22.12H12.91Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.26 7.71997H20.51V8.46997H21.26V7.71997Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.32 3.21997H16.57V3.96997H17.32V3.21997Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.16 3.31997V1.33997H20.61V3.31997H18.63V3.85997H20.61V5.83997H21.16V3.85997H23.13V3.31997H21.16Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.37 3.85997H2.41V16.86H12.37V3.85997Z",
    fill: "#D3F8F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.62 12.16H12.91V22.12H20.62V12.16Z",
    fill: "#D3F8F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.37 17.41H2.41V22.12H12.37V17.41Z",
    fill: "#7CE9DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPanelAddIllustration);
export default __webpack_public_path__ + "static/media/ic-panel-add-illustration.2099c969a78e242ce3bc01a8fc611a13.svg";
export { ForwardRef as ReactComponent };